import MCIcon from '@/components/icons/mc-icon/mc-icon';
import { RouteLessonsModel, SuggestionContentModel, SuggestionsModel } from '@/models/marker/reroute';
import { contentAPI } from '@/providers/apis/content/content';
import { searchAPI } from '@/providers/apis/search/search';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({
    name: 'suggestion-list-panel',
    components: {
      'mc-icon': MCIcon,
    },
})
export default class SuggestionListPanel extends Vue {

    // ----------------------------------------------------------
    // Properties

    private suggestionList: SuggestionsModel[] = [];

    @Prop()
    private lesson!: RouteLessonsModel;

    @Prop()
    private suggestedItems!: SuggestionsModel[];

    @Watch('suggestedItems', {deep: true})
    private onChangeSuggestions() {
      this.suggestionList = this.suggestedItems.filter((item) => !item.isActive);
    }

    // ----------------------------------------------------------
    // Hooks

    private created() {
      this.onChangeSuggestions();
    }


    // ----------------------------------------------------------
    // Actions

    private onSuggestion(suggestion: any) {
        this.$emit('onSuggestion', suggestion);

    }

    private onPreview(content: any) {
        this.fetchAssessmentDetails(content);
    }

    private goBack() {
      this.$emit('goBack');
    }

    // ----------------------------------------------------------
    // Methods

    private fetchAssessmentDetails(content: SuggestionsModel) {
        const isResourceContent = content.format.indexOf('resource') !== -1;
        const format = isResourceContent ? content.format.split('-')[1] : content.format;
        const resourceData: SuggestionContentModel[] | any = content.contents;
        if (isResourceContent) {
          const resource: SuggestionContentModel = resourceData[0] || {};
          const params = {
            q: resource.originalContentId,
          };
          const searchContent =  resource.format === 'resource'
            ? searchAPI.fetchResources(params) : searchAPI.fetchQuestions(params);
          searchContent.then((assessmentData) => {
            this.$emit('onPreview', assessmentData.searchResults[0]);
          });
        } else {
          const params: any = {
            q: content.id,
          };
          if (content.format === 'lesson') {
            searchAPI.fetchLessons(params).then((lessonData) => {
              this.$emit('onPreview', lessonData[0]);
            });
          } else {
            params['flt.collectionType'] = content.format,
            searchAPI.fetchCollections(params).then((assessmentData) => {
              this.$emit('onPreview', assessmentData.searchResults[0]);
            });
          }
        }

      }


}
